import VehicleChoiceModel from './vehicle-choice-model.vue'
export default VehicleChoiceModel
